export default __webpack_public_path__ + "static/sirio-4-62702c5cdb4b7d7f942d4994e91a0ea2.jpg";